import { ReactComponent as SubjectPropertyMarkerSVG } from "../../images/subjectPropertyMarker.svg";


export const SubjectPropertyMarker = () => {
  return (
    <SubjectPropertyMarkerSVG width={46} height={57} />
  );
};